if (!customElements.get('custom-modal')) {
  customElements.define(
    'custom-modal',
    class Modal extends HTMLElement {
      constructor() {
        super();
        this.triggers = document.querySelectorAll(`[data-toggle="modal"][data-target="#${this.id}"]`);
        this.triggers.forEach((trigger) => {
          trigger.addEventListener('click', this.show.bind(this, trigger));
        });
        this.close = this.querySelector('button.modal__close-button');
        this.close.addEventListener('click', this.hide.bind(this));
        this.backdrop = this.querySelector('.modal-overlay');
        this.backdrop.addEventListener('click', this.hide.bind(this));
      }

      hide() {
        document.body.classList.remove('overflow-hidden');
        this.setAttribute('aria-hidden', 'true');
      }

      show(opener) {
        document.body.classList.add('overflow-hidden');
        this.setAttribute('aria-hidden', 'false');
      }
    }
  );
}
